<template>
  <BaseCard :title="'Climbing Hold Classifier'" :highlightLastWord="false">
    <div class="flex flex-col justify-center gap-4">
      <div class="w-full grid lg:grid-cols-2 lg:gap-20">
        <h5 class="lg:justify-self-end lg:pr-6 font-medium">Solo Engineer</h5>
        <h5 class="lg:justify-self-start lg:pl-6 font-medium">January 2026 - Present</h5>
      </div>

      <p class="text-center items-center px-4 gap-2">
        <span class="block">
          As part of my Computer Vision class, I designed a 5-stage Computer Vision pipeline for classifying climbing holds in images
          into 7 classes. This whole project started from a climbing joke as none of us can tell the difference between a jug and
          a sloper (look it up, it's painful), so I wanted to see if AI could do any better. 
        </span>
        <span class="block">
          The pipeline begins with a trained YOLO11n object detection model to detect climbing holds, followed by 
          cropping and CLAHE normalization to enhance contrast. Next, a SAM segmentation model segments the climbing hold from the
          background, which is then passed into a trained ResNet-18 CNN to extract features. Finally, the extracted features are passed
          into a RBF-kernel SVM to classify the climbing hold.
        </span>
        <span class="block">
          Since I could not find a dataset of climbing hold images that meet the image requirements that I designed, I collected 
          and labeled 2000 climbing hold images from Notre Dame's climbing wall, taken from my phone at 5 different angles for each hold.
          I then split the dataset into a 70/15/15 train/validation/test split, then trained and validated 8 different pipeline architectures.
        </span>
        <span class="block">
          After finding the best performing architecture, the final pipeline achieved 80.2% test accuracy.
        </span>
        <a href="https://github.com/cgreen2048/Climbing-Hold-Classifier" target="_blank">
            View my 
            <span class="link-in-text">
                Github Repo
            </span>
        </a>
    </p>
    <span class="flex flex-col place-items-center overflow-hidden">
        <img class="w-[50%] h-auto rounded-lg cursor-pointer"  :src="JugClass" @click="openImageMenu(JugClass, 'Jug Class Screenshot', $event.currentTarget)">
    </span>
    </div>
  </BaseCard>
</template>

<script lang="ts" setup>
import BaseCard from '@/features/global/BaseCard.vue';
import JugClass from '@/assets/Projects/ClimbingHoldClassifierPhotos/JugClass.jpg';
import { useImageViewer } from '@/features/composables/useImageViewer';

const { openImageMenu } = useImageViewer();
</script>